(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.NBBDiscountPageCore = api;
})(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  function clean(value) {
    return typeof value === 'string' ? value.trim() : '';
  }

  function normalizeEmail(value) {
    return clean(value).toLowerCase();
  }

  function isValidEmail(value) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(normalizeEmail(value));
  }

  function buildSignupPayload(email, context) {
    context = context || {};
    return {
      email: normalizeEmail(email),
      lang: clean(context.lang) || 'en',
      source: 'discount_page_v1',
      turnstileToken: clean(context.turnstileToken)
    };
  }

  function safeResult(value) {
    if (!value || value.ok !== true) return null;
    if (!/^NBB-[A-HJ-NP-Z2-9]{10}$/.test(clean(value.couponCode))) return null;
    if (value.couponPercent !== 10) return null;
    var expiresAt = clean(value.expiresAt);
    if (!expiresAt || !Number.isFinite(Date.parse(expiresAt))) return null;
    var result = { couponCode: value.couponCode, couponPercent: 10, expiresAt: expiresAt };
    if (typeof value.isReturningClaim === 'boolean') result.isReturningClaim = value.isReturningClaim;
    return result;
  }

  function formatExpiry(value, locale) {
    var timestamp = Date.parse(clean(value));
    if (!Number.isFinite(timestamp)) return '';
    try {
      return new Intl.DateTimeFormat(clean(locale) || 'en', {
        year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC'
      }).format(new Date(timestamp));
    } catch (_error) {
      return new Intl.DateTimeFormat('en', {
        year: 'numeric', month: 'long', day: 'numeric', timeZone: 'UTC'
      }).format(new Date(timestamp));
    }
  }

  function isExpired(value, now) {
    var timestamp = Date.parse(clean(value));
    if (!Number.isFinite(timestamp)) return true;
    var current = now instanceof Date ? now.getTime() : Date.now();
    return timestamp <= current;
  }

  return {
    normalizeEmail: normalizeEmail,
    isValidEmail: isValidEmail,
    buildSignupPayload: buildSignupPayload,
    safeResult: safeResult,
    formatExpiry: formatExpiry,
    isExpired: isExpired
  };
});
